import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-df84e3d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "loading-indicator" };
const _hoisted_2 = _withScopeId(() => _createElementVNode("div", { class: "spinning-loader" }, null, -1));
const _hoisted_3 = _withScopeId(() => _createElementVNode("p", null, "Loading", -1));
const _hoisted_4 = [
    _hoisted_2,
    _hoisted_3
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4));
}
